// Mock data for Pusha Teez

export const EXPERIENCE_DROPDOWN = [
  'Live Screen Printing',
  'Heat Press',
  'Embroidery',
  'Laser Engraving',
  'Sublimation',
  'Hand Jet Print',
  'Vinyl Plotting',
  'Chain Stitch',
];

export const BRANDS = [
  'Apple', 'Nike', 'Levis', 'Hulu', 'Instagram', 'Ford', 'Hilton',
  'Warner Bros', 'Toyota', 'Spotify', 'TikTok', 'Disney', 'NBA',
  'Adidas', 'Lexus', 'Coinbase', 'Netflix', 'NFL', 'American Express'
];

export const EXPERIENCE_WORDS = [
  { word: 'Full Production', to: '/production', img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/94j66qvq_4.JPG', rotate: -4 },
  { word: 'Artist Merch', to: '/artist-merch', img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/mkb6swuk_3.JPG', rotate: 3 },
  { word: 'Brands & Companies', to: '/who-we-serve/brands-companies', img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/cjt10eb1_2.JPG', rotate: -2 },
  { word: 'Live Events', to: '/live-events', img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/ieuntttw_1.JPG', rotate: 4 },
];

export const BENTO_SECTIONS = [
  {
    id: 'tailored-products',
    title: 'Tailored Products,\nOn Demand',
    body: 'Elevate your event with on-site customization designed for impact. Our team adapts seamlessly across products and techniques to ensure high-quality results — helping you create merchandise that leaves a lasting impression.',
    img: 'https://images.unsplash.com/photo-1773525912586-fbc51bbe0fdf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxjdXN0b20lMjB0LXNoaXJ0fGVufDB8fHx8MTc3ODAyNDE5OHww&ixlib=rb-4.1.0&q=85',
  },
  {
    title: 'Your Brand,\nCenter Stage',
    body: 'We drop your brand right into the action with live customization experiences that pull people in. From start to finish, it\u2019s all about connection — so the merch hits, and the moment sticks.',
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/o965msbu_AP1A1009.jpg',
  },
  {
    title: 'We Keep It Moving',
    body: 'From festivals to corporate activations, our mobile customization experience keeps your brand in motion. We create live, personalized moments that connect with your audience long after the event ends.',
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/yush0nks_AP1A0888.jpg',
  },
  {
    id: 'merch-booths',
    title: 'Merch Booths,\nFully Managed',
    body: 'From load-in to breakdown, we handle every detail of your merch booth experience with precision and professionalism. Our team manages setup, staffing, inventory, customer flow, and on-site operations — so you can focus on the event while we handle the rest.',
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/831cz4vh_AP1A0875.jpg',
  },
  {
    title: 'Merch That\nMoves Culture',
    body: 'Today\u2019s audiences want experiences, not just giveaways. We create merch moments that feel personal, shareable, and deeply connected to the energy of your event.',
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/fggat0de_8850CC1F-55D9-4131-906E-E982896B2B85.JPG',
  },
];

// Bento sections used on the Artist Merch page. Independent copy so it
// can be edited without affecting the home-page bento.
export const ARTIST_BENTO_SECTIONS = [
  {
    title: 'Merchandise\nBranding',
    body: 'We help artists and brands build merchandise that feels authentic, elevated, and culturally relevant. From creative direction to product selection, every piece is designed to strengthen your identity and connect with your audience.',
    media: [
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/562bw4b0_1.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/pdee6d1t_2.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/nfszkh5w_3.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/rbr1ltce_4.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/z72uqckd_5.jpg' },
    ],
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/562bw4b0_1.JPG',
  },
  {
    title: 'Creative Design\n& Strategy',
    body: 'Strong brands start with strong creative. We develop cohesive merch concepts, visual direction, and release strategies that align with your audience, campaigns, tours, and brand goals.',
    media: [
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/k9kgdxzp_1.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/dscx76gu_2.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/6ecfo6fh_3.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/3n9rp1z1_4.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/w383x0wk_5.JPG' },
    ],
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/k9kgdxzp_1.JPG',
  },
  {
    title: 'Product Sourcing\n& Production',
    body: 'From premium blanks to specialty packaging, we source and produce merchandise built to match your brand quality and audience expectations. Every detail is curated to elevate the final product experience.',
    media: [
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/74vksiq5_1.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/mxa700dj_2.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/efodrpck_3.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/wr8xms4x_4.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/35qlu3o9_5.JPG' },
    ],
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/74vksiq5_1.JPG',
  },
  {
    title: 'E-Commerce\nManagement',
    body: 'We build and manage online stores that create seamless shopping experiences while keeping your products, inventory, and fulfillment running smoothly. From storefront setup to packaging and shipping coordination, we ensure every order reflects your brand experience from start to finish.',
    media: [
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/zfyifuxz_1.png' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/458ir231_2.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/wekfntv4_3.png' },
      { type: 'video', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/m3ppbvkz_4.MP4' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/o8be2avi_5.JPG' },
    ],
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/zfyifuxz_1.png',
  },
  {
    title: 'End-to-End Merch\nOperations',
    body: 'We manage the full merchandise lifecycle — from creative planning and production to fulfillment and live event execution. Every process is built to support smooth operations, consistent quality, and scalable growth.',
    media: [
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/f21rf9y8_1.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/gxmyel9v_2.jpg' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/j1x3w2b2_3.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/2vq6bpjg_4.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/tsyht82m_5.JPG' },
    ],
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/f21rf9y8_1.JPG',
  },
];

export const EXPERIENCES = [
  { name: 'Screen Printing', img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/6pf7h1aa_naomi-august-ZQPekfTkImw-unsplash.jpg' },
  { name: 'Embroidery', img: 'https://images.unsplash.com/photo-1657668282135-b620193e7801?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxlbWJyb2lkZXJ5fGVufDB8fHx8MTc3ODAyNDE5OHww&ixlib=rb-4.1.0&q=85' },
  { name: 'DTF Printing', img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/1y82tf7x_heat-press-heat-transfer-001.jpg' },
  { name: 'DTG Printing', img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/ivn1rl5q_DTG.png' },
  { name: 'Cut and Sew', img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/d43mij2o_cut-and-sew-factory.webp' },
  { name: 'Sublimation', img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/jbye9tw6_Sub.jpg' },
  { name: 'Print-on-Demand', img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/gqhkmnd7_6.JPG' },
  { name: 'Graphic Design', img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/7hs6rtzc_graphic%20design.jpg' },
];

export const CASE_STUDIES = [
  {
    title: 'Ice-T x Garden Amp',
    method: 'Live Printing',
    media: [
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/sjdnb2r6_1.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/xfspxp5t_2.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/dur51oig_3.JPG' },
      { type: 'video', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/xpfrl2nz_4.MP4' },
    ],
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/sjdnb2r6_1.JPG',
  },
  {
    title: 'Rhyme Fest LA',
    method: 'Live Printing',
    media: [
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/qcomuikv_1.jpg' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/aerrvfav_2.png' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/2x4ug2z2_3.png' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/5ycf0l22_4.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/9ijhi8wu_5.JPG' },
    ],
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/qcomuikv_1.jpg',
  },
  {
    title: 'GZA x Garden Amp',
    method: 'Live Printing',
    media: [
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/2yn67zau_GZA%20-%20001.jpg' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/1xei78s4_GZA%20-%20002.jpg' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/jsrzr8sq_GZA%20-%20003.jpg' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/pz4zun12_GZA%20-%20004.JPG' },
      { type: 'video', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/2a8uxms4_GZA%20-%20005.MP4' },
    ],
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/2yn67zau_GZA%20-%20001.jpg',
  },
  {
    title: 'Jay Electronica x The Compound',
    method: 'Live Printing',
    media: [
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/spnk3r7v_1.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/ukd738s5_2.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/s4gue562_3.JPG' },
      { type: 'video', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/44gwuh25_4.MP4' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/74a2q2el_5.JPG' },
    ],
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/spnk3r7v_1.JPG',
  },
  {
    title: 'DJ Quik x Garden Amp',
    method: 'Live Printing',
    media: [
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/mlr4gwqn_1.JPG' },
      { type: 'video', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/y8u70a5b_2.MP4' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/rdclggsh_3.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/x2zfmd2p_4.JPG' },
    ],
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/mlr4gwqn_1.JPG',
  },
  {
    title: 'Character Show x Saint One',
    method: 'Live Printing',
    media: [
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/p899xvin_1.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/52d5mhrf_2.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/b1947par_3.JPG' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/bqhm0s8b_4.JPG' },
      { type: 'video', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/3qdoobc4_5.MP4' },
    ],
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/p899xvin_1.JPG',
  },
];

export const BLOG_POSTS = [
  {
    tags: 'Live Customization, Brand Awareness, Brand Merch',
    title: 'The Ultimate Guide to On-Site Brand Activation',
    date: 'Jun 5, 2026',
    img: 'https://images.unsplash.com/photo-1456456496250-d5e7c0a9b44d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxzY3JlZW4lMjBwcmludGluZ3xlbnwwfHx8fDE3NzgwMjQxOTh8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    tags: 'Live Activation, Event Marketing, Brand Merch',
    title: 'The Role of Custom Tees in Memorable Brand Activations',
    date: 'Jan 27, 2026',
    img: 'https://images.unsplash.com/photo-1628068311627-0f5abce65050?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxjdXN0b20lMjB0LXNoaXJ0fGVufDB8fHx8MTc3ODAyNDE5OHww&ixlib=rb-4.1.0&q=85',
  },
  {
    tags: 'Events, Live Customization, Marketing',
    title: 'How to Create Event Merch That Amplifies Brand Identity',
    date: 'Jan 9, 2026',
    img: 'https://images.unsplash.com/photo-1538329972958-465d6d2144ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxzdHJlZXR3ZWFyJTIwZmFzaGlvbnxlbnwwfHx8fDE3NzgwMjQyMTJ8MA&ixlib=rb-4.1.0&q=85',
  },
];

// Tee designs produced by Pusha Teez (shown in the home marquee and on /work as Production).
export const TEE_DESIGNS = [
  { name: 'AZ — Doe or Die', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/v62ria7x_TEE-AZ.png' },
  { name: 'C-Los', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/fzz4il1a_TEE-C%20LOS.png' },
  { name: 'Champion Sounds x Garden Amp', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/24tkqzhw_TEE-CHAMP%20SOUNDS%20X%20AMP.png' },
  { name: 'Coyote', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/9fl859qu_TEE-COYOTE.png' },
  { name: 'dead prez', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/yjy13ozf_TEE-DEAD%20PREZ.png' },
  { name: 'Dilla Day 26', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/76exokhg_TEE-DILLA%20DAY%2026.png' },
  { name: 'Ghostface Killah x Panic in LA', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/lmll6i65_TEE-GFK%20X%20PANIC%20.png' },
  { name: 'DJ Quik x The Arrow Room', src: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/0cqfie48_TEE-QUIK%20X%20AAROW%20ROOM.png' },
];
